<template>
  <v-btn color="text" text v-bind="$attrs" v-on="$listeners">
    <slot/>
  </v-btn>
</template>

<script>
export default {
  name: "DialogBtn",
}
</script>
